import React from 'react'
import { TEXT_PROPS } from './interface'
import { TextWrapper } from './CustomReplyStyles'

function Text({ text, margin }: TEXT_PROPS) {
  return <TextWrapper margin={margin}>{text}</TextWrapper>
}

export default Text
